import React from 'react';
import { Box, Alert, Button, Typography, useTheme } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { usePortfolioWithPrices } from '../hooks/usePortfolioWithPrices';
import PortfolioSummary from './PortfolioSummary';
import PortfolioHoldings from './PortfolioHoldings';
import CurrentPortfolioSkeleton from './CurrentPortfolioSkeleton';

const CurrentPortfolio: React.FC = () => {
  const { data, isLoading, error, isRefetching } = usePortfolioWithPrices();
  const navigate = useNavigate();
  const theme = useTheme();

  // Show skeleton during initial load
  if (isLoading) {
    return <CurrentPortfolioSkeleton holdingCount={8} />;
  }

  // Optional: Show skeleton during refresh (uncomment if preferred over opacity fade)
  // if (isRefetching) {
  //   return <CurrentPortfolioSkeleton holdingCount={data?.holdings?.length || 8} />;
  // }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 3 }}>
        Failed to load portfolio data: {error.message}
      </Alert>
    );
  }

  if (!data) {
    return (
      <Box
        sx={{
          textAlign: "center",
          py: 8,
          px: 4,
          backgroundColor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.02)"
              : "rgba(0, 0, 0, 0.01)",
          borderRadius: 3,
          border: `2px dashed ${
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.1)"
              : "rgba(0, 0, 0, 0.1)"
          }`,
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontWeight: 600,
            color: "text.secondary",
          }}
        >
          No portfolio data available
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Upload your trading history to start tracking your portfolio performance
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<AddIcon />}
          onClick={() => navigate('/portfolio/manage')}
          sx={{
            borderRadius: 3,
            px: 4,
          }}
        >
          Add Holdings
        </Button>
      </Box>
    );
  }


  return (
    <Box>
      <PortfolioSummary 
        summary={data.summary} 
        isRefetching={isRefetching}
        totalPositions={data.holdings?.filter(h => h.shares > 0.000001).length || 0}
      />
      
      <Box mt={4}>
        <PortfolioHoldings holdings={data.holdings} isRefetching={isRefetching} />
      </Box>
    </Box>
  );
};

export default CurrentPortfolio;